import { logError } from "@/shared/logging/errors";
import { useOperatorSettingsStore } from "@/data/stores/operatorSettings";


export class SocketEventHelper {
    public static triggerFulfillmentDataEvent(fulfillmentGroupId: string | undefined | null): boolean {
        if (fulfillmentGroupId == null || fulfillmentGroupId.length === 0) {
            return true;
        }

        const operatorSettingsStore = useOperatorSettingsStore();
        const selectedFulfillmentGroups = operatorSettingsStore.operatorSettings?.fulfillmentGroups;

        if (operatorSettingsStore.operatorSettings == null) {
            logError("Operator's settings are missing");
            return true;
        }

        if (
            selectedFulfillmentGroups == null ||
            selectedFulfillmentGroups?.length === 0 ||
            selectedFulfillmentGroups.find((fg) => fg.id === fulfillmentGroupId) != null
        ) {
            return true;
        } else {
            console.log(`Fulfillment with fulfillment group ${fulfillmentGroupId} can be ignored.`);
            return false;
        }
    }
}